export default "__VITE_ASSET__333b57d6__"